import { EventEmitter, Injectable } from "@angular/core";

@Injectable({
    providedIn: "root"
})
export class CustCardTabService {
    notificationTabChanged: EventEmitter<number> = new EventEmitter<number>();
    notificationTab: number = 2;

    tabChanged: EventEmitter<number> = new EventEmitter<number>();
    tab: number = 57;
    tabTitle: string = "פרטים אישיים";

    isCommentsExist: boolean = false;
    isTasksExist: boolean = false;

    constructor() { }

    get notificationTabIndex(): number {
        return this.notificationTab;
    }
    set notificationTabIndex(value: number) {
        if (this.notificationTab != value) {
            this.notificationTab = value;
            this.notificationTabChanged.emit(value);
        }
    }

    get tabIndex(): number {
        return this.tab;
    }
    set tabIndex(value: number) {
        if (this.tab != value) {
            this.tab = value;
            this.tabChanged.emit(value);
        }
    }
}
